import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { contents } from '@/mocks/contents';
import { featuredSpotlight } from '@/mocks/home';
import { pillClass } from '@/lib/ui';

const findItem = (id: string) => contents.find((item) => item.id === id);

const FeaturedSection = () => {
  const spotlight = findItem(featuredSpotlight.id) || contents[0];
  const sideItems = contents.filter((item) => item.id === 'c-02' || item.id === 'c-06');

  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              kicker="编辑精选"
              title="本周焦点，值得完整看完的几条"
              desc="从实时热度、画质与讨论度三个维度挑选，每一条都经得起回看。"
            />
            <Link
              to="/category"
              className="inline-flex w-fit items-center gap-1.5 text-sm font-label text-primary-600 transition-colors hover:text-primary-700"
            >
              查看全部内容
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <article className="group relative h-80 w-full overflow-hidden rounded-lg md:h-[520px]">
              <img
                src={featuredSpotlight.image}
                alt={spotlight.title}
                title={`${spotlight.title} - 在线看料`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <span className={`${pillClass} bg-accent-500 text-foreground-950`}>
                  {featuredSpotlight.kicker}
                </span>
                <h3 className="mt-3 max-w-xl font-heading text-xl font-semibold leading-snug text-background-50 md:text-3xl">
                  <Link to={`/content/${spotlight.id}`} className="transition-colors hover:text-accent-200">
                    {spotlight.title}
                  </Link>
                </h3>
                <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-200 sm:block">
                  {spotlight.summary}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-4 text-xs font-label text-background-200">
                  <span className="inline-flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-play-circle-line text-sm" />
                    </span>
                    {spotlight.views} 次观看
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-timer-line text-sm" />
                    </span>
                    {spotlight.duration}
                  </span>
                  <span className="rounded-md bg-background-50/20 px-2 py-0.5 backdrop-blur">
                    {spotlight.quality}
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="flex flex-col gap-5 lg:col-span-5">
            {sideItems.map((item, index) => (
              <Reveal key={item.id} delay={index * 100} className="flex-1">
                <article className="group flex h-full gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                  <Link
                    to={`/content/${item.id}`}
                    className="relative h-24 w-28 shrink-0 overflow-hidden rounded-md sm:w-40"
                    aria-label={item.title}
                  >
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} - 在线看料`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute bottom-1.5 right-1.5 rounded bg-foreground-950/70 px-1.5 py-0.5 text-[10px] font-label text-background-50">
                      {item.duration}
                    </span>
                  </Link>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <span className="text-[11px] font-label text-primary-600">{item.categoryName}</span>
                    <h3 className="mt-1.5 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                      <Link to={`/content/${item.id}`} className="transition-colors hover:text-primary-600">
                        {item.title}
                      </Link>
                    </h3>
                    <p className="mt-2 line-clamp-2 hidden text-xs leading-relaxed text-foreground-600 sm:block">
                      {item.summary}
                    </p>
                    <div className="mt-auto flex items-center gap-3 pt-3 text-[11px] font-label text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-fire-line text-sm text-accent-600" />
                        热度 {item.hot}
                      </span>
                      <span>{item.views}</span>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;